import { inject } from '@vercel/analytics';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'App';
import { dispatchChunkError } from 'components/NewVersionBar/NewVersionBar';
import 'i18n';
import 'index.css';
import reportWebVitals from 'reportWebVitals';
import { reportError } from 'utils/errorReporting';
import { sendToVercelAnalytics } from 'vitals';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Suppress ResizeObserver loop error (benign; often from charts/layout in same frame)
const resizeObserverErr = /ResizeObserver loop completed with undelivered notifications/;

// On chunk load failure: show "New version available" bar instead of auto-reload
const chunkLoadErr = /Loading chunk \d+ failed|ChunkLoadError|Loading CSS chunk|\(missing:|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

const originalOnError = window.onerror;
window.onerror = (message, source, ...rest) => {
  if (typeof message === 'string' && resizeObserverErr.test(message)) {
    return true;
  }
  if (typeof message === 'string' && chunkLoadErr.test(message)) {
    dispatchChunkError();
    return true;
  }
  reportError(message, 'window.onerror');
  return originalOnError ? Boolean(originalOnError(message, source, ...rest)) : false;
};

window.addEventListener('error', (e) => {
  if (resizeObserverErr.test(e.message)) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
  if (chunkLoadErr.test(e.message)) {
    dispatchChunkError();
  } else {
    reportError(e.error ?? e.message, 'error event');
  }
});

window.addEventListener('unhandledrejection', (e) => {
  reportError(e.reason, 'unhandledrejection');
});

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

if (process.env.REACT_APP_VERCEL_ANALYTICS_ID) {
  inject();
  reportWebVitals(sendToVercelAnalytics);
}

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    navigator.serviceWorker.register(`${base}/sw.js`).catch(() => {});
  });
}
